<mat-toolbar class="main-toolbar" [ngClass]="{'header-bg-admin': isAdminRoute}">
  <a routerLink="/" class="logo-link">
    <img class="logo-image" [src]="branding.logoUrl" [alt]="branding.displayName">
  </a>

  <div class="nav-links desktop-nav">
    <a mat-button routerLink="/league" class="league-button" *ngIf="isLeagueEnabled()">
      <span>League</span>
    </a>
    <a mat-button routerLink="/tournament" (click)="closeMenu()" *ngIf="isFeatureEnabled('settings') && isPageVisible('tournament')">
      <span>Tournament</span>
    </a>
    <a mat-button routerLink="/rules-regulations" (click)="closeMenu()" *ngIf="isFeatureEnabled('public_site') && isPageVisible('rules_regulations')">
      <span>Rules & Regulations</span>
    </a>
    <a mat-button routerLink="/about-us" (click)="closeMenu()" *ngIf="isFeatureEnabled('public_site') && isPageVisible('about_us')">
      <span>About Us</span>
    </a>
  </div>


  <span class="spacer"></span>

  <button #mobileMenuButton mat-icon-button class="mobile-menu-button" (click)="toggleMenu()"
    aria-label="Toggle navigation" [attr.aria-expanded]="isMenuOpen" [attr.aria-controls]="mobileMenuId">
    <mat-icon>{{ isMenuOpen ? 'close' : 'menu' }}</mat-icon>
  </button>

  <ul class="auth-links">
    @if (userIsAuthenticated) {
      <li>
        <a mat-button routerLink="/my-dashboard" class="profile-link">
          My Dashboard
        </a>
      </li>
    } @else {
      <li>
        <button mat-button routerLink="/auth/login">
          Sign In
        </button>
      </li>
    }
  </ul>
</mat-toolbar>

<div class="mobile-overlay" *ngIf="isMenuOpen" (click)="closeMenu()">
  <nav #mobileMenu class="mobile-overlay-menu" [id]="mobileMenuId" role="dialog" aria-modal="true"
    aria-label="Mobile navigation" [class.menu-closing]="isMenuClosing"
    (click)="$event.stopPropagation()" (keydown)="onMobileMenuKeydown($event)">
    <button class="mobile-close-button" (click)="closeMenu()" aria-label="Close menu">
      <mat-icon>close</mat-icon>
    </button>
 <a mat-button class="mobile-overlay-item" routerLink="/league" (click)="closeMenu()" *ngIf="isLeagueEnabled()">League</a> <a mat-button class="mobile-overlay-item" routerLink="/tournament" (click)="closeMenu()" *ngIf="isFeatureEnabled('settings') && isPageVisible('tournament')">Tournament</a>
    <a mat-button class="mobile-overlay-item" routerLink="/about-us" (click)="closeMenu()" *ngIf="isFeatureEnabled('public_site') && isPageVisible('about_us')">About Us</a>
    <a mat-button class="mobile-overlay-item" routerLink="/rules-regulations" (click)="closeMenu()" *ngIf="isFeatureEnabled('public_site') && isPageVisible('rules_regulations')">Rules & Regulations</a>
    @if (userIsAuthenticated) {
      <a mat-button class="mobile-overlay-item mobile-profile-link" routerLink="/my-dashboard" (click)="closeMenu()">
        My Dashboard
      </a>
    } @else {
      <a mat-button class="mobile-overlay-item mobile-profile-link" routerLink="/auth/login" (click)="closeMenu()">
        Sign In
      </a>
    }
  </nav>
</div>
